
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { InventoryList } from "@/components/inventory/InventoryList";
import { PurchaseRequestList } from "@/components/inventory/PurchaseRequestList";
import { StorageLocationList } from "@/components/inventory/StorageLocationList";
import { useSearchParams, useNavigate } from "react-router-dom";

export default function Inventory() {
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get("tab") || "items";
  const navigate = useNavigate();

  const handleTabChange = (value: string) => {
    navigate(`/inventory?tab=${value}`);
  };

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-6">Inventory Management</h1>
      
      <Tabs defaultValue={defaultTab} className="space-y-6" onValueChange={handleTabChange}>
        <TabsList>
          <TabsTrigger value="items">Inventory Items</TabsTrigger>
          <TabsTrigger value="requests">Purchase Requests</TabsTrigger>
          <TabsTrigger value="locations">Storage Locations</TabsTrigger>
        </TabsList>
        
        <TabsContent value="items" className="space-y-6">
          <InventoryList />
        </TabsContent>
        
        <TabsContent value="requests" className="space-y-6">
          <PurchaseRequestList />
        </TabsContent>

        <TabsContent value="locations" className="space-y-6">
          <StorageLocationList />
        </TabsContent>
      </Tabs>
    </div>
  );
}
